import {
  AppData,
  CompRef,
  DocumentServicesObject,
} from '@wix/document-services-types';
import { EventType, PanelResolveType } from '@wix/editor-platform-sdk-types';
import { PlatformContext } from '../../types/platformApi';
import { t } from '../../essentials/i18n';
import { getEditorInfo } from '../../utils';
import { reportBi } from '../../essentials';

export function openAddElementsPanelIfExist(
  documentServices: DocumentServicesObject,
  componentRef: CompRef,
) {
  const { applicationId } =
    documentServices.components.data.get(componentRef) ?? {};

  const addElementsAction =
    documentServices.platform.controllers.getStageData(componentRef)?.gfpp
      ?.desktop?.iconButtons?.add;

  const shouldOpenPanel = addElementsAction && applicationId;

  if (shouldOpenPanel) {
    documentServices.platform.notifyApplicationByAppDefId(applicationId, {
      eventPayload: {
        componentRef,
        id: addElementsAction.actionId,
      },
      eventType: EventType.widgetGfppClicked,
    });
  }

  return shouldOpenPanel;
}

const getPremiumPackagePickerUrl = (
  documentServices: DocumentServicesObject,
  premiumFeatureName: string,
): string => {
  const metaSite = documentServices.generalInfo.getMetaSiteId();
  const host = getEditorInfo()?.host;
  const hostPath = host === 'EDITOR' ? 'dynamo' : 'studio';
  return `https://manage.wix.com/premium-purchase-plan/${hostPath}?siteGuid=${metaSite}&referralAdditionalInfo=pages-panel-actions-${premiumFeatureName}`;
};

export async function openUpgradeSiteConfirmationPanel(
  documentServices: DocumentServicesObject,
  context: PlatformContext,
  appDefId: string,
  premiumFeatureName: string,
) {
  const appApi = await documentServices.platform.getAppEditorApi(appDefId);
  const modalContent = await appApi?.getUpgradeSitePanelContent?.({
    premiumFeatureName,
  });
  const premiumPackagePickerUrl = getPremiumPackagePickerUrl(
    documentServices,
    premiumFeatureName,
  );
  if (!modalContent) {
    return window.open(premiumPackagePickerUrl, '_blank');
  }
  const panelName = 'platformPanels.UpgradeSiteConfirmationPanel';
  reportBi(140, {
    panel_name: panelName,
    target_type: 'premium confirmation flow',
    host_app_id: appDefId,
  });
  return context.platformApiMethods.editor.openConfirmationPanel(
    {} as AppData,
    '',
    {
      headerText: modalContent?.title ?? '',
      descriptionText: modalContent?.descriptionText ?? '',
      helpId: modalContent?.helpId ? modalContent.helpId : undefined,
      mainActionText: t('UpgradetoContinue_Modal_Upgrade_CTA'),
      secondaryActionText: t('UpgradetoContinue_Modal_MaybeLater_CTA'),
      shouldShowIllustration: false,
      theme: 'premium',
      onClose: (origin) => {
        if (origin === PanelResolveType.MAIN_ACTION) {
          reportBi(142, {
            panel_name: panelName,
            action: 'Upgrade Now',
          });
          window.open(premiumPackagePickerUrl, '_blank');
        }
      },
    },
  );
}
